<template v-if="this.isConnect">
  <div class="events-page">
    <v-layout class="mx-3 mt-3" row wrap>
      <v-flex xs6 sm6 md3>
        <h1 class="subtitle-1 grey--text">
          {{ $t("scheduler.event.list.title") }}
        </h1>
      </v-flex>
      <v-flex :order-3="$vuetify.breakpoint.smAndDown" xs12 sm12 md6>
        <v-text-field
          v-model="search"
          prepend-icon="search"
          :label="$t('app.forms.search')"
        ></v-text-field>
      </v-flex>
      <v-flex xs6 sm6 md3 text-right>
        <div>
          <v-btn
            dark
            small
            tile
            width="80"
            :color="!past ? '#666' : 'mdred'"
            @click="toPast()"
          >
            {{ $t("scheduler.misc.past") }}
          </v-btn>
          <v-btn
            dark
            small
            tile
            width="80"
            :color="past ? '#666' : 'mdred'"
            @click="toFuture()"
          >
            {{ $t("scheduler.misc.future") }}
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
    <Progression v-if="loading"></Progression>
    <div v-else class="events">
      <v-container class="my-5">
        <v-layout row wrap>
          <v-flex
            v-for="event in eventsPool"
            :key="event.id"
            class="px-2 py-2"
            xs12
            md6
            lg4
          >
            <v-card flat height="350px" class="overflow-hidden">
              <div
                class="lessonNum white--text"
                :class="{
                  mdred: !event.deletion,
                  grey: event.deletion
                }"
              >
                <v-container>
                  <v-layout>
                    <span>
                      {{ displayDateToText(new Date(event.start)) }}
                    </span>
                  </v-layout>
                </v-container>
              </div>
              <v-img
                :src="
                  event.image
                    ? event.image
                    : require('@/assets/images/event-placeholder.png')
                "
                aspect-ratio="2.75"
                class="event-image"
              ></v-img>
              <v-card-title primary-title>
                <div>
                  <h3 class="headline mb-2">{{ event.title }}</h3>
                  <div class="body-2">{{ event.abstract }}</div>
                </div>
              </v-card-title>
            </v-card>
            <v-btn
              outlined
              block
              class=""
              @click="$router.push('/classes/' + event.id)"
              >{{ $t("scheduler.event.list.details-button") }}</v-btn
            >
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import Progression from "@/components/Progression";

export default {
  name: "Cours",
  components: {
    Progression
  },

  data() {
    return {
      loading: false,
      events: [],
      past: false,
      search: ""
    };
  },

  computed: {
    eventsPool: function() {
      if (!this.events) {
        return [];
      }
      let self = this;
      const result = this.events.filter(function(event) {
        if (
          self.search &&
          !self.compareSearchValue(event.title) &&
          !self.compareSearchValue(event.abstract) &&
          !self.compareSearchValue(event.description)
        ) {
          return false;
        }
        return true;
      });
      return result;
    }
  },

  mounted() {
    this.$nextTick(async function() {
      this.getEvents();
    });
  },

  methods: {
    compareSearchValue(val) {
      return val && val.toLowerCase().includes(this.search.toLowerCase());
    },

    toPast() {
      if (this.past) {
        return;
      }
      this.past = true;
      this.events = [];
      this.getEvents();
    },

    toFuture() {
      if (!this.past) {
        return;
      }
      this.past = false;
      this.events = [];
      this.getEvents();
    },

    getEvents() {
      let self = this;
      this.loading = true;
      const today = this.dateToText(new Date());
      let params = {
        seeCancelled: true
      };
      if (this.past) {
        params.end = today;
      } else {
        params.start = today;
      }
      this.$store
        .dispatch("scheduler/getEvents", params)
        .then(res => success(res));
      var success = function(res) {
        self.events = res;
        self.events.sort((a, b) => {
          const A = new Date(a.start);
          const B = new Date(b.start);
          return (self.past ? -1 : 1) * (A - B);
        });
        self.loading = false;
      };
    },

    dateToText(date) {
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();

      return (
        year +
        "-" +
        (month < 10 ? "0" + month : month) +
        "-" +
        (day < 10 ? "0" + day : day)
      );
    },

    displayDateToText(date) {
      const base = this.dateToText(date);
      const hours = date.getHours();
      const minutes = date.getMinutes();

      return (
        base +
        " " +
        this.$t("app.general.at") +
        " " +
        (hours < 10 ? "0" + hours : hours) +
        "h" +
        (minutes < 10 ? "0" + minutes : minutes)
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@media (max-width: 960px) {
  .event-image {
    max-height: 220px;
  }
}
</style>
